import { useContext } from "react";

import { AgendaItemViewsContext } from "./AgendaItemViewsContext";

export function useAgendaItemViews() {
  const context = useContext(AgendaItemViewsContext);
  if (!context) {
    throw new Error("useAgendaItemViews must be used within a AgendaItemViewsProvider");
  }
  return context;
}
